import React from "react";
import { MODULE_ROUTE } from "./module-router";

export const dashboardRouter = [
  {
    path: MODULE_ROUTE.DASHBOARD,
    component: React.lazy(() => import("../features/dashboard/page/dashboard-page")),
  },
  {
    path: MODULE_ROUTE.BRANCH,
    component: React.lazy(() => import("../features/management-branch/page/branch-page")),
  },
  {
    path: MODULE_ROUTE.EMPLOYEE,
    component: React.lazy(() => import("../features/management-employee/page/employee/employee-page")),
  },
  {
    path: MODULE_ROUTE.COMPUTERS,
    component: React.lazy(() => import("../features/management-computers/page/computers-page")),
  },
  {
    path: MODULE_ROUTE.LIST_DEPARTMENT,
    component: React.lazy(() => import("../features/management-employee/page/department/department-page")),
  },
  {
    path: MODULE_ROUTE.LIST_ACCOUNT_CUSTOMER,
    component: React.lazy(() => import("../features/management-account/page/list-account-page")),
  },
  {
    path: MODULE_ROUTE.ID_VERIFICATION,
    component: React.lazy(() => import("../features/management-account/page/id-verification-page")),
  },
  {
    path: MODULE_ROUTE.WORKSTATION_AREA,
    component: React.lazy(() => import("../features/workstation-area/page/workstation-area-page")),
  },
  {
    path: MODULE_ROUTE.CHANGE_PASSWORD,
    component: React.lazy(() => import("../features/auth/page/change-password-page")),
  },
  {
    path: MODULE_ROUTE.RECHARGE_PACKAGE,
    component: React.lazy(() => import("../features/management-recharge-package/page/recharge-package-page")),
  },
  {
    path: MODULE_ROUTE.PROFILE,
    component: React.lazy(() => import("../features/auth/page/profile-page")),
  },
  {
    path: MODULE_ROUTE.WAREHOUSING,
    component: React.lazy(
      () => import("../features/management-product-and-warehousing/warehousing/page/warehousing-page")
    ),
  },
  {
    path: MODULE_ROUTE.MANAGEMENT_GAME,
    component: React.lazy(() => import("../features/management-game/page/game/game-page")),
  },
  {
    path: MODULE_ROUTE.CATEGORY_GAME,
    component: React.lazy(() => import("../features/management-game/page/category-game/category-game-page")),
  },
  {
    path: MODULE_ROUTE.BOOKING_MANAGEMENT,
    component: React.lazy(() => import("../features/booking/page/booking-page")),
  },
  {
    path: MODULE_ROUTE.MANAGEMENT_NEWFEED,
    component: React.lazy(() => import("../features/management-newfeed/page/management-newfeed-page")),
  },
  {
    path: MODULE_ROUTE.ORDER,
    component: React.lazy(() => import("../features/management-order/page/order-list-page")),
  },
  {
    path: MODULE_ROUTE.CATEGORY,
    component: React.lazy(() => import("../features/management-product-and-warehousing/page/categories-product-page")),
  },
  {
    path: MODULE_ROUTE.RECHARGE_HISTORY,
    component: React.lazy(() => import("../features/management-recharge-history/page/recharge-history-page")),
  },
  {
    path: MODULE_ROUTE.BANK_TRANSFER_QUEUE,
    component: React.lazy(() => import("../features/management-bank-transfer/page/bank-transfer-queue-page")),
  },
  {
    path: MODULE_ROUTE.SETTINGS,
    component: React.lazy(() => import("../features/setting/page/settings-page")),
  },
  {
    path: MODULE_ROUTE.INCOME_AND_EXPENDITURE,
    component: React.lazy(
      () =>
        import("../features/management-product-and-warehousing/income-and-expenditure/page/income-and-expenditure-page")
    ),
  },
  {
    path: MODULE_ROUTE.CHAT,
    component: React.lazy(() => import("../features/chat/page/chat-page")),
  },
  {
    path: MODULE_ROUTE.CATEGORIES_RECEIPT_PAGE,
    component: React.lazy(() => import("../features/management-product-and-warehousing/page/categories-receipt-page")),
  },
  {
    path: MODULE_ROUTE.MATERIAL_AND_PRODUCT,
    component: React.lazy(
      () => import("../features/management-product-and-warehousing/page/material-and-product-page")
    ),
  },
  {
    path: MODULE_ROUTE.INVENTORY_WAREHOUSE,
    component: React.lazy(
      () => import("../features/management-product-and-warehousing/inventory-warehouse/page/inventory-warehouse-page")
    ),
  },
  {
    path: MODULE_ROUTE.TIMEKEEPING_USER_PAGE,
    component: React.lazy(() => import("../features/timekeeping-user/page/timekeeping-user-page")),
  },
  {
    path: MODULE_ROUTE.SHIFT_SESSION,
    component: React.lazy(() => import("../features/shift-session/page/shift-session-page")),
  },
  {
    path: MODULE_ROUTE.SHIFT_PAGE,
    component: React.lazy(() => import("../features/management-shift/page/shift-page")),
  },
  {
    path: MODULE_ROUTE.PROMOTION_COMBO_PAGE,
    component: React.lazy(() => import("../features/promotion/combo/page/promotion-combo-page")),
  },
  {
    path: MODULE_ROUTE.PROMOTION_TICKET_PAGE,
    component: React.lazy(() => import("../features/promotion/ticket/page/promotion-ticket-page")),
  },
  {
    path: MODULE_ROUTE.PROMOTION_CUSTOMER_DISCOUNT_PAGE,
    component: React.lazy(
      () => import("../features/promotion/customer-discount/page/promotion-customer-discount-page")
    ),
  },
  {
    path: MODULE_ROUTE.PROMOTION_AREA_DISCOUNT_PAGE,
    component: React.lazy(() => import("../features/promotion/area-discount/page/promotion-area-discount-page")),
  },
  {
    path: MODULE_ROUTE.PROMOTION_RECHARGE_PACKAGE_MILESTONES_PAGE,
    component: React.lazy(
      () => import("../features/promotion/page/recharge-package-milestones/promotion-recharge-package-milestones-page")
    ),
  },
  {
    path: MODULE_ROUTE.PROMOTION_MEMBERSHIP_LEVEL_PAGE,
    component: React.lazy(() => import("../features/promotion/page/membership-level/promotion-membership-level-page")),
  },
  {
    path: MODULE_ROUTE.PROMOTION_BUY_HISTORY,
    component: React.lazy(() => import("../features/promotion/buy-history/page/buy-history-page")),
  },
  {
    path: MODULE_ROUTE.EMPLOYEE_NOTIFICATION_HISTORY,
    component: React.lazy(
      () => import("../features/employee-notification-history/page/employee-notification-history-page")
    ),
  },
  {
    path: MODULE_ROUTE.PRINTER_PAGE,
    component: React.lazy(() => import("../features/printer/page/printer-page")),
  },
  {
    path: MODULE_ROUTE.BACKGROUND_LOGIN,
    component: React.lazy(() => import("../features/background-login/background-login-page")),
  },
  {
    path: MODULE_ROUTE.MANAGEMENT_SERVICE,
    component: React.lazy(() => import("../features/management-service/page/service-page")),
  },
  {
    path: MODULE_ROUTE.PRODUCT,
    component: React.lazy(() => import("../features/products/page/product-page")),
  },
  {
    path: MODULE_ROUTE.API_KEY,
    component: React.lazy(() => import("../features/api-key/page/api-key-page")),
  },
  {
    path: MODULE_ROUTE.TIMELINE,
    component: React.lazy(() => import("../features/timeline")),
  },
  // Promotion Masters (New)
  {
    path: MODULE_ROUTE.PROMOTION_MASTERS,
    component: React.lazy(() => import("../features/promotion-masters/page/promotion-masters-page")),
  },
  {
    path: MODULE_ROUTE.PROMOTION_MASTERS_CREATE,
    component: React.lazy(() => import("../features/promotion-masters/page/promotion-master-create-page")),
  },
  {
    path: MODULE_ROUTE.PROMOTION_MASTERS_EDIT,
    component: React.lazy(() => import("../features/promotion-masters/page/promotion-master-create-page")),
  },
  {
    path: MODULE_ROUTE.PROMOTION_MASTERS_DETAIL,
    component: React.lazy(() => import("../features/promotion-masters/page/promotion-master-create-page")),
  },
  {
    path: MODULE_ROUTE.PROMOTION_REPORTS,
    component: React.lazy(() => import("../features/promotion-masters/page/promotion-reports-page")),
  },
  // Voucher Templates (New)
  {
    path: MODULE_ROUTE.VOUCHER_TEMPLATES,
    component: React.lazy(() => import("../features/vouchers/page/voucher-templates-page")),
  },
  {
    path: MODULE_ROUTE.VOUCHER_TEMPLATES_CREATE,
    component: React.lazy(() => import("../features/vouchers/page/voucher-template-create-page")),
  },
  {
    path: MODULE_ROUTE.VOUCHER_TEMPLATES_EDIT,
    component: React.lazy(() => import("../features/vouchers/page/voucher-template-create-page")),
  },
  // Vouchers List (New)
  {
    path: MODULE_ROUTE.VOUCHERS,
    component: React.lazy(() => import("../features/vouchers/page/vouchers-page")),
  },
  // Reports Dashboard (New)
  {
    path: MODULE_ROUTE.REPORTS_DASHBOARD,
    component: React.lazy(() => import("../features/reports/page/reports-dashboard-page")),
  },
  {
    path: MODULE_ROUTE.REPORT_REVENUE,
    component: React.lazy(() => import("../features/reports/page/revenue-report-page")),
  },
  {
    path: MODULE_ROUTE.REPORT_COMPUTER_PERFORMANCE,
    component: React.lazy(() => import("../features/reports/page/computer-performance-page")),
  },
  {
    path: MODULE_ROUTE.REPORT_WORKSTATION_STATUS,
    component: React.lazy(() => import("../features/reports/page/workstation-status-page")),
  },
  {
    path: MODULE_ROUTE.REPORT_PRODUCT_SALES,
    component: React.lazy(() => import("../features/reports/page/product-sales-page")),
  },
  {
    path: MODULE_ROUTE.REPORT_SHIFT_CLOSE,
    component: React.lazy(() => import("../features/reports/page/shift-close-page")),
  },
  {
    path: MODULE_ROUTE.PROMOTION_CREDIT_PAGE,
    component: React.lazy(() => import("../features/promotion/promotion-credit/page/promotion-credit-page")),
  },
  {
    path: MODULE_ROUTE.PLAY_TIME_PACKAGE,
    component: React.lazy(() => import("../features/management-play-time-package/page/play-time-package-page")),
  },
  {
    path: MODULE_ROUTE.PLAY_TIME_TRANSACTIONS,
    component: React.lazy(() => import("../features/management-play-time-package/page/play-time-transaction-page")),
  },
  {
    path: MODULE_ROUTE.ZALO_OA_INBOX,
    component: React.lazy(() => import("../features/zalo-oa-inbox/page/zalo-oa-inbox-page")),
  },
];
